
let API_ENDPOINT;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  API_ENDPOINT = 'http://localhost:8000/dfat-ai'
} else {
  API_ENDPOINT = 'https://api.tetun.org/dfat-ai'
}

export { API_ENDPOINT };
